export default __webpack_public_path__ + "static/media/logo-desktop.3a9f6e88.png";